// import { filter } from "lodash";
import { sentenceCase } from "change-case";
import { useState, forwardRef, useEffect, useRef } from "react";
import { Icon } from "@iconify/react";
import plusFill from "@iconify/icons-eva/plus-fill";
import pinFill from "@iconify/icons-eva/pin-fill";
import { useNavigate, useLocation, useSearchParams } from "react-router-dom";
import CheckIcon from "@mui/icons-material/Check";
import AccountTreeRoundedIcon from "@mui/icons-material/AccountTreeRounded";
import DoNotDisturbAltIcon from "@mui/icons-material/DoNotDisturbAlt";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import roundAccountTree from "@iconify/icons-ic/round-account-tree";
import sharpArrowDropUp from "@iconify/icons-ic/sharp-arrow-drop-up";
import sharpArrowDropDown from "@iconify/icons-ic/sharp-arrow-drop-down";
import ClearIcon from "@mui/icons-material/Clear";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import { Portal } from "@mui/base";
import {
  Card,
  Table,
  Stack,
  Button,
  TextField,
  TableRow,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  Divider,
  Box,
  Chip,
  FormControl,
  InputLabel,
  Select,
  FormHelperText,
  MenuItem,
  OutlinedInput,
  Link,
} from "@mui/material";
import Page from "../components/Page";
import Label from "../components/Label";
import Scrollbar from "../components/Scrollbar";
import CloseIcon from "@mui/icons-material/Close";
import {
  LocationListHead,
  LocationListToolbar,
  LocationMoreMenu,
} from "../components/_dashboard/location";
import { filter } from "lodash";
import { sort } from "fast-sort";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import Pagination from "@mui/material/Pagination";
import LinearProgress from "@mui/material/LinearProgress";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { CallApi } from "../statics.js";

const Alert = forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function SlideTransition(props) {
  return <Slide {...props} direction="left" />;
}
// ----------------------------------------------------------------------
function applySortFilter(array, order, orderBy, query) {
  let list = array;
  let result = [];
  if (order === "asc") {
    result = sort(list).by([
      {
        asc: (u) => {
          if (typeof u[orderBy] === "string" || u[orderBy] instanceof String)
            return u[orderBy].toLowerCase();
          else return u[orderBy];
        },
      },
      { asc: (u) => u.createdAt },
    ]);
  } else {
    result = sort(list).by([
      {
        desc: (u) => {
          if (typeof u[orderBy] === "string" || u[orderBy] instanceof String)
            return u[orderBy].toLowerCase();
          else return u[orderBy];
        },
      },
      { desc: (u) => u.createdAt },
    ]);
  }

  if (query) {
    return filter(
      result,
      (_user) => _user.title.toLowerCase().indexOf(query.toLowerCase()) !== -1
    );
  }

  return result;
}

const TABLE_HEAD = [
  { id: "title", label: "Title", alignRight: false },
  { id: "lineId", label: "Product", alignRight: false },
  { id: "priceType", label: "Price Type", alignRight: false },
  { id: "descr", label: "Description", alignRight: false },
  { id: "priority", label: "Priority", alignRight: false },
  { id: "items", label: "Items", alignRight: false },
  { id: "" },
];

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function Additional() {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const [open, setOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackType, setSnackType] = useState(false);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [infoDialogOpen, setInfoDialogOpen] = useState(false);
  const [currentLocItem, setCurrentLocItem] = useState({ title: "" });
  const [actionMode, setActionMode] = useState("accepting");
  const [dialogMode, setDialogMode] = useState("add");
  const [additionalTitle, setAdditionalTitle] = useState("");
  const [additionalTitleErrorText, setAdditionalTitleErrorText] = useState("");
  const [additionalDes, setAdditionalDes] = useState("");
  const [additionalDesErrorText, setAdditionalDesErrorText] = useState("");

  const [minHeight, setMinHeight] = useState("");
  const [minHeightErrorText, setMinHeightErrorText] = useState("");
  const [maxHeight, setMaxHeight] = useState("");
  const [maxHeightErrorText, setMaxHeightErrorText] = useState("");
  const [minWidth, setMinWidth] = useState("");
  const [minWidthErrorText, setMinWidthErrorText] = useState("");
  const [maxWidth, setMaxWidth] = useState("");
  const [maxWidthErrorText, setMaxWidthErrorText] = useState("");
  const [obsoletedValue, setObsoletedValue] = useState("");
  const [obsoletedValueErrorText, setObsoletedValueErrorText] = useState("");
  const [addDialogOpen, setAddDialogOpen] = useState(false);

  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("priority");
  const [filterName, setFilterName] = useState("");

  const [dataLoading, setDataLoading] = useState(true);
  const [tableData, setTableData] = useState([]);
  const [tempTableData, setTempTableData] = useState([]);
  const [productValue, setProductValue] = useState("");
  const [productValueErrorText, setProductValueErrorText] = useState("");
  const [productList, setProductList] = useState([]);
  const [currentAdditionalItem, setCurrentAdditionalItem] = useState({
    id: "",
    title: "",
  });

  const [config, setConfig] = useState(null);
  const [priceTypeList, setPriceTypeList] = useState([]);
  const [priceTypeValue, setPriceTypeValue] = useState("");
  const [priceTypeValueErrorText, setPriceTypeValueErrorText] = useState("");

  const [priorityValue, setPriorityValue] = useState("");
  // const [priorityValueErrorText, setPriorityValueErrorText] = useState("");
  const [urlValue, setUrlValue] = useState("");
  const [urlValueErrorText, setUrlValueErrorText] = useState("");

  const [modelsList, setModelsList] = useState([]);
  const [modelValue, setModelValue] = useState("");
  const [modelValueErrorText, setModelValueErrorText] = useState("");
  const [modelItemsList, setModelItemsList] = useState([]);
  const [selectedModelItemsValue, setSelectedModelItemsValue] = useState([]);
  const [
    selectedModelItemsValueErrorText,
    setSelectedModelItemsValueErrorText,
  ] = useState("");
  const [tempSelectedModelItemsValue, setTempSelectedModelItemsValue] =
    useState([]);

  const [stepsList, setStepsList] = useState([]);
  const [stepValue, setStepValue] = useState("");
  const [stepValueErrorText, setStepValueErrorText] = useState("");
  const [stepItemsList, setStepItemsList] = useState([]);
  const [selectedStepItemsValue, setSelectedStepItemsValue] = useState([]);
  const [tempSelectedStepItemsValue, setTempSelectedStepItemsValue] = useState(
    []
  );
  const [selectedStepItemsValueErrorText, setSelectedStepItemsValueErrorText] =
    useState("");
  const [isRequired, setIsRequired] = useState(false);
  const [isHidden, setIsHidden] = useState(false);

  // const [filteredDataList, setFilteredDataList] = useState([]);

  const [searchParams, setSearchParams] = useSearchParams();

  const navigate = useNavigate();

  const notChange = useRef(false);

  function getCookie(cname) {
    let name = cname + "=";
    let ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  useEffect(() => {
    getConfig();
  }, []);

  const getConfig = () => {
    let data = {
      username: getCookie("username"),
      token: getCookie("token"),
    };
    setDataLoading(true);
    CallApi("getConfig", "post", data).then((result) => {
      try {
        if (result.status === 200) {
          console.log(result.result.priceTypes);
          setConfig(result.result);
          setPriceTypeList(result.result.priceTypes);
        }
      } catch (error) {
        console.log("error: ", error);
      }
    });
  };

  useEffect(() => {
    if (config) {
      getAllLines();
    }
  }, [config]);

  const getAllLines = () => {
    let data = {
      username: getCookie("username"),
      token: getCookie("token"),
      page: 0,
      count: 1000,
    };
    CallApi("getAllLines", "post", data).then((result) => {
      try {
        if (result.status === 200) {
          setProductList(result.result);
          getAllSteps();
        }
      } catch (error) {
        console.log("error: ", error);
      }
    });
  };

  const getAllSteps = () => {
    let data = {
      username: getCookie("username"),
      token: getCookie("token"),
      page: 0,
      count: 1000,
    };
    CallApi("getAllSteps", "post", data).then((result) => {
      try {
        if (result.status === 200) {
          setStepsList(result.result);
          getAllAdditionals();
        }
      } catch (error) {
        console.log("error: ", error);
      }
    });
  };

  const getAllAdditionals = () => {
    let data = {
      username: getCookie("username"),
      token: getCookie("token"),
      page: page,
      count: rowsPerPage,
    };
    setDataLoading(true);
    CallApi("getAllAdditionals", "post", data).then((result) => {
      try {
        console.log(result);
        if (result.status === 200) {
          let res = [...result.result];
          res.forEach((element) => {
            config.priceTypes.forEach((element1) => {
              if (element.priceType === element1.id) {
                element.priceTypeTitle = element1.title;
              }
            });
          });

          // setTableData(res);
          setTableData(res);
          setTotalItems(result.paginateInfo.totalItems);
        }
        setDataLoading(false);
      } catch (error) {
        console.log("error: ", error);
      }
    });
  };

  const findModelItems = (id) => {
    let data = {
      username: getCookie("username"),
      token: getCookie("token"),
      modelId: id[0],
      page: 0,
      count: 1000,
    };
    console.log(data);
    setButtonDisabled(true);
    CallApi("findModelItems", "post", data).then((result) => {
      try {
        console.log(result);
        if (result.status === 200) {
          setModelItemsList(result.result);
          // notChange.current = false;
        }
        setButtonDisabled(false);
      } catch (error) {
        console.log("error: ", error);
      }
    });
  };

  const findItemswithPath = (id) => {
    let data = {
      username: getCookie("username"),
      token: getCookie("token"),
      parentList: id,
      page: 0,
      count: 1000,
    };
    setButtonDisabled(true);
    CallApi("findItemswithPath", "post", data).then((result) => {
      try {
        if (result.status === 200) {
          setStepItemsList(result.result);
          notChange.current = false;
        }
        setButtonDisabled(false);
      } catch (error) {
        console.log("error: ", error);
      }
    });
  };

  useEffect(() => {
    if (tableData.length > 0) {
      setDataLoading(false);
      // setFilteredDataList(
      //   applySortFilter(tableData, order, orderBy, filterName)
      // );

      // console.log("tableeeee:", tableData);
    }
  }, [tableData]);

  // useEffect(() => {
  //   console.log("filter: ", filteredDataList);
  // }, [filteredDataList]);

  // useEffect(() => {
  //   if (tempTableData.length > 0) setTableData([]);
  // }, [tempTableData]);

  const handleChangePage = (e, value) => {
    setPage(value);
  };

  useEffect(() => {
    if (tableData.length > 0) getAllAdditionals();
  }, [page]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  // const handleFilterByName = (event) => {
  //   setFilterName(event.target.value);
  // };

  // useEffect(() => {
  //   if (addDialogOpen) additionalTitleTextField.current.focus();
  // }, [addDialogOpen]);

  const handleClickOpen = () => {
    setDialogMode("add");
    setAdditionalTitle("");
    setAdditionalDes("");
    setProductValue("");
    setProductValueErrorText("");
    setAdditionalTitleErrorText("");
    setModelValue("");
    setSelectedModelItemsValue([]);
    setStepValue("");
    setSelectedStepItemsValue([]);
    setUrlValue("");
    setPriorityValue("");
    // setPriorityValueErrorText("");
    setPriceTypeValue([priceTypeList[0].id]);
    setModelValueErrorText("");
    setSelectedModelItemsValueErrorText("");
    setStepValueErrorText("");
    setSelectedStepItemsValueErrorText("");
    setUrlValueErrorText("");
    setPriceTypeValueErrorText("");
    setAddDialogOpen(true);
    setCurrentAdditionalItem({ title: "" });
    setIsRequired(false);
    setIsHidden(false);
  };

  const addAdditional = () => {
    if (!additionalTitle) {
      setAdditionalTitleErrorText("Additional title cannot be empty");
      return;
    } else {
      setAdditionalTitleErrorText("");
    }

    if (!productValue) {
      setProductValueErrorText("Product cannot be empty");
      return;
    } else {
      setProductValueErrorText("");
    }

    // if (!modelValue) {
    //   setModelValueErrorText("Model cannot be empty");
    //   return;
    // } else {
    //   setModelValueErrorText("");
    // }

    if (modelValue && selectedModelItemsValue.length < 1) {
      setSelectedModelItemsValueErrorText("Model item cannot be empty");
      return;
    } else {
      setSelectedModelItemsValueErrorText("");
    }

    // if (!stepValue) {
    //   setStepValueErrorText("Step cannot be empty");
    //   return;
    // } else {
    //   setStepValueErrorText("");
    // }

    if (stepValue && selectedStepItemsValue.length < 1) {
      setSelectedStepItemsValueErrorText("Step item cannot be empty");
      return;
    } else {
      setSelectedStepItemsValueErrorText("");
    }

    // if (!priorityValue) {
    //   setPriorityValueErrorText("Priority cannot be empty");
    //   return;
    // } else {
    //   setPriorityValueErrorText("");
    // }
    // if (!urlValue) {
    //   setUrlValueErrorText("URL cannot be empty");
    //   return;
    // } else {
    //   setUrlValueErrorText("");
    // }
    if (!priceTypeValue) {
      setPriceTypeValueErrorText("Price Type cannot be empty");
      return;
    } else {
      setPriceTypeValueErrorText("");
    }

    console.log(isRequired);
    console.log(isHidden);
    let data = {
      username: getCookie("username"),
      token: getCookie("token"),
      title: additionalTitle ? additionalTitle : "",
      descr: additionalDes ? additionalDes : "",
      pic: "",
      lineId: productValue[0],
      modelItemList: selectedModelItemsValue,
      stepItemList: selectedStepItemsValue,
      priority: priorityValue,
      url: urlValue,
      priceType: priceTypeValue[0],
      isRequired: isRequired,
      isHide: isHidden,
    };
    let apiname = "createNewAdditional";

    if (dialogMode === "update") {
      data = {
        username: getCookie("username"),
        token: getCookie("token"),
        additionalId: currentAdditionalItem._id,
        title: additionalTitle ? additionalTitle : "",
        descr: additionalDes ? additionalDes : "",
        pic: "",
        lineId: productValue[0],
        modelItemList: selectedModelItemsValue,
        stepItemList: selectedStepItemsValue,
        priority: priorityValue,
        url: urlValue,
        priceType: priceTypeValue[0],
        isRequired: isRequired,
        isHide: isHidden,
      };
      apiname = "updateAdditional";
    }

    console.log(data);
    setButtonDisabled(true);

    CallApi(apiname, "post", data)
      .then((result) => {
        try {
          console.log(result);
          if (result.status === 200) {
            getAllAdditionals();
            setSnackType("success");

            if (apiname === "createNewAdditional")
              setSnackbarMessage(
                "'" + additionalTitle + "' has been added successfully"
              );
            else
              setSnackbarMessage(
                "'" + additionalTitle + "' has been updated successfully"
              );

            setSnackbarOpen(true);
            setAddDialogOpen(false);
          } else {
            setSnackType("error");
            setSnackbarMessage(result.message);
            setSnackbarOpen(true);
          }
          setButtonDisabled(false);
        } catch (error) {
          console.log("error: ", error);
        }
      })
      .catch((err) => {
        setSnackType("error");
        setSnackbarMessage(err);
        setSnackbarOpen(true);
        setButtonDisabled(false);
      });
  };

  const onEditItem = (item) => {
    if (!buttonDisabled) {
      console.log(item);
      notChange.current = true;
      setCurrentAdditionalItem(item);
      setDialogMode("update");
      setAdditionalTitle(item.title);
      setAdditionalDes(item.descr);
      setProductValue([item.lineId]);
      setIsRequired(item.isRequired ? item.isRequired : false);
      setIsHidden(item.isHide ? item.isHide : false);
      setPriorityValue(
        item.priority || item.priority === 0 ? item.priority : ""
      );
      setModelValue(
        item.modelItemListObj.length > 0
          ? [item.modelItemListObj[0].modelId]
          : ""
      );
      // console.log(item.priceType ? item.priceType : [priceTypeList[0].id]);
      setSelectedModelItemsValue(item.modelItemList);

      // let found = false;
      // stepsList.forEach((element) => {
      //   if (item.stepItemListObj.length>0 element.id === item.stepItemListObj[0].path.replaceAll(",", ""))
      //     found - true;
      // });
      // if (!found) {
      //   setStepValue("");
      // } else {
      //   setStepValue(
      //     item.stepItemListObj.length > 0
      //       ? [item.stepItemListObj[0].path.replaceAll(",", "")]
      //       : ""
      //   );
      // }

      setStepValue(
        item.stepItemListObj.length > 0
          ? [item.stepItemListObj[0].path.replaceAll(",", "")]
          : ""
      );

      setSelectedStepItemsValue(
        item.stepItemListObj.length > 0 ? item.stepItemList : []
      );
      setUrlValue(item.url);

      setPriceTypeValue(
        item.priceType ? [item.priceType] : [priceTypeList[0].id]
      );

      setAdditionalTitleErrorText("");
      setProductValueErrorText("");
      setModelValueErrorText("");
      setSelectedModelItemsValueErrorText("");
      setStepValueErrorText("");
      setSelectedStepItemsValueErrorText("");
      setUrlValueErrorText("");
      setPriceTypeValueErrorText("");
      setAddDialogOpen(true);
    }
  };

  const onDeleteItem = (item) => {
    if (!buttonDisabled) {
      setCurrentAdditionalItem(item);
      setDeleteDialogOpen(true);
    }
  };

  const handleChangeProduct = (event) => {
    const {
      target: { value },
    } = event;
    setProductValue(typeof value === "string" ? value.split(",") : value);
  };

  useEffect(() => {
    if (productValue) {
      if (!notChange.current) setModelValue("");
      let data = {
        username: getCookie("username"),
        token: getCookie("token"),
        lineId: productValue[0],
        page: 0,
        count: 1000,
      };
      console.log(data);
      setButtonDisabled(true);
      CallApi("findAllModelsWithLineId", "post", data).then((result) => {
        try {
          console.log(result);
          if (result.status === 200) {
            setModelsList(result.result);
          }
          setButtonDisabled(false);
        } catch (error) {
          console.log("error: ", error);
        }
      });
    }
  }, [productValue]);

  const swapElements = (array, index1, index2) => {
    let temp = array[index1];
    array[index1] = array[index2];
    array[index2] = temp;
    return array;
  };

  // const changeAdditionalPriority = (newArray, oldArray) => {
  //   let list = [];
  //   let i = 0;
  //   newArray.forEach((element) => {
  //     list.push({ id: element.id, priority: i });
  //     i++;
  //   });

  //   let data = {
  //     username: getCookie("username"),
  //     token: getCookie("token"),
  //     priorityList: list,
  //   };
  //   console.log(data);
  //   setButtonDisabled(true);
  //   CallApi("changeAdditionalPriority", "post", data)
  //     .then((result) => {
  //       try {
  //         console.log(result);
  //         if (result.status !== 200) {
  //           setSnackType("error");
  //           setSnackbarMessage(result.message);
  //           setSnackbarOpen(true);
  //           setTableData(oldArray);
  //         }
  //         setButtonDisabled(false);
  //       } catch (error) {
  //         setSnackType("error");
  //         setSnackbarMessage(error);
  //         setSnackbarOpen(true);
  //       }
  //     })
  //     .catch((errMessage) => {
  //       setSnackType("error");
  //       setSnackbarMessage(errMessage);
  //       setSnackbarOpen(true);
  //     });
  // };

  useEffect(() => {
    if (!notChange.current) setSelectedModelItemsValue([]);
    if (modelValue) {
      console.log("modelValue:", modelValue);
      findModelItems(modelValue);
    } else {
      setSelectedModelItemsValue([]);
      setModelItemsList([]);
    }
  }, [modelValue]);

  useEffect(() => {
    if (!notChange.current) setSelectedStepItemsValue([]);
    if (stepValue) {
      findItemswithPath(stepValue);
    } else {
      setSelectedStepItemsValue([]);
      setStepItemsList([]);
    }
  }, [stepValue]);

  const handleChangeModel = (event) => {
    const {
      target: { value },
    } = event;
    setModelValue(typeof value === "string" ? value.split(",") : value);
  };
  const handleChangeModelItems = (event) => {
    const {
      target: { value },
    } = event;
    setSelectedModelItemsValue(
      typeof value === "string" ? value.split(",") : value
    );
  };
  const handleChangeStep = (event) => {
    const {
      target: { value },
    } = event;
    setStepValue(typeof value === "string" ? value.split(",") : value);
  };
  const handleChangeStepItems = (event) => {
    const {
      target: { value },
    } = event;
    setSelectedStepItemsValue(
      typeof value === "string" ? value.split(",") : value
    );
  };

  const handleChangePriceType = (event) => {
    const {
      target: { value },
    } = event;
    setPriceTypeValue(typeof value === "string" ? value.split(",") : value);
  };

  const confirmDeleteItem = () => {
    setDeleteDialogOpen(false);

    let data = {
      username: getCookie("username"),
      token: getCookie("token"),
      additionalId: currentAdditionalItem._id,
    };

    console.log(data);

    setButtonDisabled(true);
    CallApi("removeAdditional", "post", data)
      .then((result) => {
        try {
          console.log(result);
          if (result.status === 200) {
            getAllAdditionals();
          }
          setButtonDisabled(false);
        } catch (error) {
          console.log("error: ", error);
        }
      })
      .catch((err) => {
        setSnackType("error");
        setSnackbarMessage(err);
        setSnackbarOpen(true);
        setButtonDisabled(false);
      });
  };

  const filteredDataList = applySortFilter(
    tableData,
    order,
    orderBy,
    filterName
  );

  const isUserNotFound = filteredDataList.length === 0;

  return (
    <Page title="Additional | Admin Panel">
      {dataLoading && (
        <LinearProgress
          color="primary"
          sx={{
            ml: -2,
            zIndex: "100000",
            width: "100%",
            position: "fixed",
            top: "0px",
          }}
        />
      )}
      {!dataLoading && (
        <Container sx={{ position: "relative" }}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            mb={5}
          >
            <Typography variant="h4" gutterBottom>
              Additional
            </Typography>
            <Button
              onClick={handleClickOpen}
              variant="contained"
              // component={RouterLink}
              // to="new"
              // state={{ type: "new" }}
              disabled={buttonDisabled}
              startIcon={<Icon icon={plusFill} />}
            >
              New Additional
            </Button>
          </Stack>

          <Card>
            {/* <LocationListToolbar
              filterName={filterName}
              searchPlaceHolder="Search title..."
              onFilterName={handleFilterByName}
            /> */}
            <Scrollbar>
              <TableContainer sx={{ minWidth: 800 }}>
                <Table>
                  <LocationListHead
                    headLabel={TABLE_HEAD}
                    rowCount={filteredDataList.length}
                    order={order}
                    orderBy={orderBy}
                    onRequestSort={handleRequestSort}
                  />
                  {!isUserNotFound && (
                    <TableBody>
                      {filteredDataList.map((row, i) => {
                        return (
                          <TableRow hover key={row._id} tabIndex={-1}>
                            <TableCell
                              component="th"
                              scope="row"
                              padding="normal"
                            >
                              <Typography variant="subtitle2" noWrap>
                                {row.title}
                              </Typography>
                            </TableCell>
                            <TableCell>{row.lineObj.title}</TableCell>
                            <TableCell>{row.priceTypeTitle}</TableCell>
                            <TableCell>{row.descr ? row.descr : "-"}</TableCell>
                            <TableCell>
                              {row.priority || row.priority === 0
                                ? row.priority
                                : "-"}
                            </TableCell>
                            <TableCell align="left">
                              <Link href={"/additional/" + row._id}>
                                <Box
                                  component={Icon}
                                  icon={roundAccountTree}
                                  sx={{
                                    color: "primary.main",
                                    width: 24,
                                    height: 24,
                                    cursor: "pointer",
                                  }}
                                />
                              </Link>
                            </TableCell>
                            <TableCell align="right">
                              <LocationMoreMenu
                                onEdit={() => onEditItem(row)}
                                onDelete={() => onDeleteItem(row)}
                              />
                            </TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  )}
                  {isUserNotFound && (
                    <TableBody>
                      <TableRow>
                        <TableCell
                          align="center"
                          colSpan={12}
                          sx={{
                            py: 3,
                            color: "text.disabled",
                            fontSize: "12px",
                          }}
                        >
                          No Data
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )}
                </Table>
              </TableContainer>
            </Scrollbar>

            <TablePagination
              rowsPerPageOptions={[]}
              component="div"
              count={totalItems}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
            />
          </Card>
        </Container>
      )}
      <Dialog
        sx={{ p: 2, mt: 2 }}
        open={deleteDialogOpen}
        TransitionComponent={Transition}
        // keepMounted
        onClose={() => setDeleteDialogOpen(false)}
      >
        <DialogTitle>Deleting Additional</DialogTitle>
        <DialogContent sx={{ maxWidth: "400px" }}>
          <DialogContentText id="alert-dialog-description">
            {"Are you sure for deleting '" + currentAdditionalItem.title + "'?"}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={confirmDeleteItem}>Yes</Button>
          <Button onClick={() => setDeleteDialogOpen(false)} color="secondary">
            No
          </Button>
        </DialogActions>
      </Dialog>

      {/* <Dialog
        sx={{ p: 2, mt: 2 }}
        open={infoDialogOpen}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => {
          setInfoDialogOpen(false);
        }}
      >
        <DialogTitle>
          {"More info about '" + currentLocItem.title + "': "}
        </DialogTitle>

        <DialogContent sx={{ maxWidth: "400px" }}>
          <Stack direction="row" spacing={1} mb={2}>
            <Typography variant="subtitle2">Farm Type: </Typography>
            <Typography variant="paragraph">
              {currentLocItem.farmType}
            </Typography>
          </Stack>
          <Stack direction="row" spacing={1} mb={2}>
            <Typography variant="subtitle2">Address: </Typography>
            <Typography variant="paragraph">
              {currentLocItem.address}
            </Typography>
          </Stack>
          <Stack direction="row" spacing={1} mb={2}>
            <Typography variant="subtitle2">Area: </Typography>
            <Typography variant="paragraph">{currentLocItem.area}</Typography>
          </Stack>

          <Stack direction="row" spacing={1} mb={2}>
            <Typography variant="subtitle2">Latitude: </Typography>
            <Typography variant="paragraph">{currentLocItem.lat}</Typography>
          </Stack>
          <Stack direction="row" spacing={1} mb={2}>
            <Typography variant="subtitle2">Longitude: </Typography>
            <Typography variant="paragraph">{currentLocItem.lon}</Typography>
          </Stack>

          <Stack direction="column" sx={{ width: "100%" }}>
            <Box
              sx={{
                width: "100%",
                minHeight: "1px",
                backgroundColor: "var(--gray2)",
              }}
              mt={3}
              mb={1}
            />
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="flex-end"
            >
              <Button
                onClick={() => {
                  setInfoDialogOpen(false);
                }}
                variant="outlined"
                disabled={buttonDisabled}
                startIcon={<ArrowBackIosIcon />}
              >
                Back
              </Button>
            </Stack>
          </Stack>
        </DialogContent>
      </Dialog> */}

      <Dialog
        sx={{ p: 2, mt: 2 }}
        open={addDialogOpen}
        TransitionComponent={Transition}
        keepMounted
        onClose={() => {
          if (!buttonDisabled) setAddDialogOpen(false);
        }}
      >
        <DialogTitle>
          {dialogMode === "add" ? "Add New Additional" : "Edit Additional"}
        </DialogTitle>
        <DialogContent sx={{ maxWidth: "400px" }}>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <FormControlLabel
              sx={{ mb: 1 }}
              control={
                <Switch
                  disabled={buttonDisabled}
                  checked={isRequired}
                  onChange={(e) => {
                    setIsRequired(e.target.checked);
                  }}
                />
              }
              label="Required"
            />
            <FormControlLabel
              sx={{ mb: 1 }}
              control={
                <Switch
                  disabled={buttonDisabled}
                  checked={isHidden}
                  onChange={(e) => {
                    setIsHidden(e.target.checked);
                  }}
                />
              }
              label="Is Hidden"
            />
          </div>
          <TextField
            fullWidth
            sx={{ mb: 2, mt: 2 }}
            autoFocus
            type="text"
            label="Title"
            value={additionalTitle}
            // inputRef={additionalTitleTextField}
            onChange={(e) => setAdditionalTitle(e.target.value)}
            disabled={buttonDisabled}
            // disabled={addAdditionalLoading}
            helperText={additionalTitleErrorText}
            error={additionalTitleErrorText ? true : false}
          />

          <TextField
            fullWidth
            sx={{ mb: 2 }}
            autoFocus
            type="text"
            label="Description"
            value={additionalDes}
            onChange={(e) => setAdditionalDes(e.target.value)}
            disabled={buttonDisabled}
            helperText={additionalDesErrorText}
            error={additionalDesErrorText ? true : false}
          />

          <FormControl
            sx={{ mb: 2 }}
            fullWidth
            disabled={buttonDisabled}
            error={productValueErrorText ? true : false}
          >
            <InputLabel>Product</InputLabel>
            <Select
              value={productValue ? productValue : ""}
              onChange={handleChangeProduct}
              input={<OutlinedInput label="Product" />}
              MenuProps={MenuProps}
            >
              {productList.map((pt) => (
                <MenuItem key={pt._id} value={pt._id}>
                  {pt.title}
                </MenuItem>
              ))}
            </Select>
            <FormHelperText>{productValueErrorText}</FormHelperText>
          </FormControl>

          <FormControl
            sx={{ mb: 2 }}
            fullWidth
            disabled={buttonDisabled || !productValue}
            error={modelValueErrorText ? true : false}
          >
            <InputLabel>Model</InputLabel>
            <Select
              IconComponent={() =>
                modelValue && modelValue.length > 0 ? (
                  <div
                    style={{
                      marginRight: "10px",
                      padding: "4px",
                      cursor: "pointer",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                    onClick={() => setModelValue("")}
                  >
                    <ClearIcon style={{ fontSize: "20px" }} />
                  </div>
                ) : null
              }
              value={modelValue ? modelValue : ""}
              onChange={handleChangeModel}
              input={<OutlinedInput label="Model" />}
              MenuProps={MenuProps}
            >
              {modelsList.map((pt) => (
                <MenuItem key={pt._id} value={pt._id}>
                  {pt.title}
                </MenuItem>
              ))}
            </Select>
            <FormHelperText>{modelValueErrorText}</FormHelperText>
          </FormControl>

          <FormControl
            sx={{ mb: 2 }}
            fullWidth
            error={selectedModelItemsValueErrorText ? true : false}
            disabled={buttonDisabled || !modelValue}
          >
            <InputLabel>Model Items</InputLabel>
            <Select
              value={selectedModelItemsValue}
              onChange={handleChangeModelItems}
              multiple
              input={<OutlinedInput label="Model Items" />}
              MenuProps={MenuProps}
            >
              {modelItemsList.map((pt) => (
                <MenuItem key={pt._id} value={pt._id}>
                  {pt.title}
                </MenuItem>
              ))}
            </Select>
            <FormHelperText>{selectedModelItemsValueErrorText}</FormHelperText>
          </FormControl>

          <FormControl
            sx={{ mb: 2 }}
            fullWidth
            disabled={buttonDisabled}
            error={stepValueErrorText ? true : false}
          >
            <InputLabel>Step</InputLabel>
            <Select
              IconComponent={() =>
                stepValue && stepValue.length > 0 ? (
                  <div
                    style={{
                      marginRight: "10px",
                      padding: "4px",
                      cursor: "pointer",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                    onClick={() => setStepValue("")}
                  >
                    <ClearIcon style={{ fontSize: "20px" }} />
                  </div>
                ) : null
              }
              value={stepValue ? stepValue : ""}
              onChange={handleChangeStep}
              input={<OutlinedInput label="Step" />}
              MenuProps={MenuProps}
            >
              {stepsList.map((pt) => (
                <MenuItem key={pt._id} value={pt._id}>
                  {pt.title}
                </MenuItem>
              ))}
            </Select>
            <FormHelperText>{stepValueErrorText}</FormHelperText>
          </FormControl>

          <FormControl
            sx={{ mb: 2 }}
            fullWidth
            error={selectedStepItemsValueErrorText ? true : false}
            disabled={buttonDisabled || !stepValue}
          >
            <InputLabel>Step Items</InputLabel>
            <Select
              value={selectedStepItemsValue}
              onChange={handleChangeStepItems}
              multiple
              input={<OutlinedInput label="Step Items" />}
              MenuProps={MenuProps}
            >
              {stepItemsList.map((pt) => (
                <MenuItem key={pt._id} value={pt._id}>
                  {pt.title}
                </MenuItem>
              ))}
            </Select>
            <FormHelperText>{selectedStepItemsValueErrorText}</FormHelperText>
          </FormControl>

          <TextField
            fullWidth
            sx={{ mb: 2 }}
            autoFocus
            type="text"
            label="Priority"
            value={priorityValue}
            onChange={(e) => setPriorityValue(e.target.value)}
            disabled={buttonDisabled}
            // helperText={priorityValueErrorText}
            // error={priorityValueErrorText ? true : false}
          />

          <TextField
            fullWidth
            sx={{ mb: 2 }}
            autoFocus
            type="text"
            label="URL"
            value={urlValue}
            onChange={(e) => setUrlValue(e.target.value)}
            disabled={buttonDisabled}
            helperText={urlValueErrorText}
            error={urlValueErrorText ? true : false}
          />

          <FormControl
            sx={{ mb: 2 }}
            fullWidth
            disabled={buttonDisabled}
            error={priceTypeValueErrorText ? true : false}
          >
            <InputLabel>Price Type</InputLabel>
            <Select
              value={priceTypeValue ? priceTypeValue : ""}
              onChange={handleChangePriceType}
              input={<OutlinedInput label="Price Type" />}
              MenuProps={MenuProps}
            >
              {priceTypeList.map((pt) => (
                <MenuItem key={pt.id} value={pt.id}>
                  {pt.title}
                </MenuItem>
              ))}
            </Select>
            <FormHelperText>{priceTypeValueErrorText}</FormHelperText>
          </FormControl>

          {buttonDisabled && (
            <LinearProgress
              color="primary"
              sx={{
                zIndex: "100000",
                width: "100%",
                position: "absolute",
                bottom: "0px",
                ml: -3,
              }}
            />
          )}
        </DialogContent>
        <DialogActions sx={{ mb: 1 }}>
          <Button
            onClick={addAdditional}
            variant="contained"
            disabled={buttonDisabled}
          >
            {dialogMode === "add" ? "Add" : "Update"}
          </Button>
          <Button
            onClick={() => setAddDialogOpen(false)}
            color="secondary"
            disabled={buttonDisabled}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>

      <Portal>
        <Snackbar
          open={snackbarOpen}
          onClose={() => setSnackbarOpen(false)}
          TransitionComponent={SlideTransition}
          autoHideDuration={6000}
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        >
          <Alert
            onClose={() => setSnackbarOpen(false)}
            severity={snackType}
            sx={{ width: "100%" }}
          >
            {snackbarMessage}
          </Alert>
        </Snackbar>
      </Portal>
    </Page>
  );
}
